import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Radio, RadioGroup, Tooltip } from '@mui/material'
import { memo, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { LoadMessages, MuteConversation, UpdateContactTypes, UpdateHistory } from '../../actions'
import setToast from '../../helpers/toaster.helper'
import { ArchivedIcon, BlockIcon, CancelIcon, DownloadChatIcon, MarkasReadIcon, MarkasUnreadIcon, MuteIcon, PinIcon, SettingsHorizIcon, TrashIcon, UnArchivedIcon, UnMuteIcon, UnpicIcon, GroupChatNewIcon, CampainNewIcon, CheckboxDefaultIcon, CheckboxCheckedIcon, SecureChatFilledIcon, ConversationSelectDark, ConversationInProgressIcon, ConversationOpenIcon, ConversationReslovedIcon, ConversationClosedIcon, AssigneeToYouUserIcon, AssigneeToAnotherUserIcon, UnAssignedIcon, StarBlackIcon } from '../../icon'
import { Contact, ContactType, ConversationCardModel, ConversationModel, StatusEnum, TypingDataModel, mapToContactType } from '../../models/conversations'
import { MediaSubHeader, MediaType } from '../../models/media.models'
import { UserModel } from '../../models/users.model'
import * as selector from "../../selectors/selectors"
import { ContactService } from '../../services/ContactService'
import { MessageService } from '../../services/MessageService'
import { SettingsService } from '../../services/SettingsService'
import { UserService } from '../../services/UserService'
import { UtilityService } from '../../services/UtilityService'
import { AppRoutes } from '../routes/route.path'
import Avatar from '../shared/avatar.component'
import ButtonComponent from '../shared/button/button.component'
import ConfirmDialog from "../shared/confirm-dialog.component"
import { ActionLabels, ToasterTexts, appNote, buttonLabels } from '../shared/constants'
import { MenuItemRender } from '../shared/menu-item-render'
import { ToasterType } from '../shared/toaster/toaster.model'
import { SecureChatService } from '../../services/SecureChatService'
import { saveBlobOnDevice } from '../../helpers/teams-mobile-download.helper'

interface IDispatchProps {
    MuteConversation: (phoneNumber: string, duration: number) => Promise<any>,
    LoadMessages: () => void,
    UpdateHistory: (phoneNumber: string, history: ConversationModel[]) => void;
    UpdateContactTypes: (data: ContactType[]) => void;

}
interface Props {
    data: ConversationCardModel;
    style: any;
    index: number,
    onClick: () => void;
    isChecked: boolean;
    onConversationSelect: (id: ConversationCardModel) => void;
    showCheckboxes: boolean;
    isEndScroll: boolean;
    handleShowMultiActionButtons: (status: boolean) => void;
    showContactInfo?: boolean;
}

const ConversationCards = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const SecureChatConversations: ConversationModel[] = useSelector(selector.secureChatConversations)
    const params = useParams();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const AllUsers: UserModel[] = useSelector(selector.allUsers)
    const TypingData: TypingDataModel[] = useSelector(selector.typingData)
    const Contacts: Contact[] = useSelector(selector.contacts)
    const { data, style, index, onClick, showContactInfo } = props
    const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState<boolean>(false)
    const [showBlockContactDialog, setShowBlockContactDialog] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showMuteForm, setShowMuteForm] = useState<boolean>(false)
    const [muteDuration, setMuteDuration] = useState<number>(1)
    const [PhoneNumberTypingData, setPhoneNumberTypingData] = useState<TypingDataModel[]>(TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.data.PhoneNumber)))
    const [text, setText] = useState<string>("")
    const [dailogButtonName, setDailogButtonName] = useState<string>("")
    const [checked, setChecked] = useState(false);
    const [isTooltipHovered, setIsTooltipHovered] = useState(false);
    const [isSecureChat, setIsSecureChat] = useState<boolean>(props.data.msgType === "secure-chat")
    const [showFolloUpIcon, setShowFollowUpIcon] = useState<boolean>(true)

    useEffect(() => {
        setShowFollowUpIcon(true)
    }, [props.data.AssignStatus])

    useEffect(() => {
        setChecked(props.isChecked);
    }, [props.isChecked]);

    useEffect(() => {
        setIsSecureChat(props.data.msgType === "secure-chat")
    }, [props.data])

    const displayMessage = (msg: any) => {
        let message = "";

        if (!isSecureChat && msg.Message?.toLowerCase() === "stop" && !msg.IsOutbound && !data.GroupChat && !data.Campaign) {
            message = appNote.UNSUBSCRIBE;
        } else if (!isSecureChat && msg.Message?.toLowerCase() === "unstop" && !msg.IsOutbound && !data.GroupChat && !data.Campaign) {
            message = appNote.RESUBSCRIBE;
        } else if (!!msg.Media?.length && (!msg.Message || msg.Message.length === 0)) {
            message = "Media"
        }
        else {
            message = msg.Message || "";
        }

        return UtilityService.trimMessage(message, 12);
    }

    const handleCardClick = (e: any) => {
        e.stopPropagation();
        onClick()
    }

    useEffect(() => {
        setPhoneNumberTypingData(TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.data.PhoneNumber)))
    }, [TypingData, props.data.PhoneNumber])

    const handelArchive = (phoneNumber: string, archived: boolean, groupChatId: string) => {
        if (isSecureChat) {
            SecureChatService.archiveSecureChat(data.ID, !archived).then((res) => {
                props.handleShowMultiActionButtons(false)
                setToast(archived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
            });
        } else {
            let archiveChat = groupChatId ? groupChatId : phoneNumber
            return MessageService.setContactAsArchived(archiveChat, !archived)
                .then((res) => {
                    props.handleShowMultiActionButtons(false)
                    setToast(archived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
                    UpdateContactTypes(dispatch, res.map(mapToContactType))
                });
        }
    }

    const handelPin = (phoneNumber: string, pinned: boolean, groupChatId: string) => {
        let pinnedChat = groupChatId ? groupChatId : phoneNumber
        MessageService.setContactAsPinned(pinnedChat, !pinned).then(res => {
            setToast(pinned ? ToasterTexts.UNPIN_SUCCES : ToasterTexts.PIN_SUCCESS, ToasterType.SUCCESS)
            UpdateContactTypes(dispatch, res.map(mapToContactType));
        }, (error) => {
            if (error?.response?.status === 400) {
                if (error?.response?.data?.code === SettingsService.Pinned_Contacts_Code) {
                    setToast(ToasterTexts.MAXIMUM_PINNED_CONV.replace("<count>", error?.response?.data?.value), ToasterType.DANGER);
                }
                else if (error?.response?.data?.message) {
                    setToast(error?.response?.data?.message, ToasterType.DANGER);
                }
            }
        });
    }

    const muteConversation = (event?: any) => {
        let muteChatName = !!data.GroupChat ? !!data.GroupChat?.Name ? UtilityService.trimMessage(data.GroupChat?.Name, 10) : "Group Chat" : !!data.Contact?.Name ? UtilityService.trimMessage(data.Contact?.Name, 10) : data?.MaskedPhoneNumber;
        MuteConversation(dispatch, data.GroupChat?.ID ? data.GroupChat?.ID : data.PhoneNumber, data.IsMuted ? 0 : muteDuration).then(res => {
            setToast(data.IsMuted ? ToasterTexts.UNMUTE_CONVERSATION.replace('<Name>', muteChatName) : ToasterTexts.MUTE_CONVERSATION.replace('<Name>', muteChatName), ToasterType.SUCCESS)
        }).catch(err => { })
        setShowMuteForm(false)
        setMuteDuration(1);
        event.stopPropagation();
    }

    const closeDeleteHistoryDialog = (isConfim: boolean, event?: any) => {
        event.stopPropagation();
        if (isConfim) {
            setIsLoading(true)
            if (!!data.Campaign?.ID) {
                MessageService.deleteCampaignHistory(data.Campaign?.ID).then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                    UpdateHistory(dispatch, data.Campaign?.ID, [])
                    LoadMessages(dispatch)
                });
            }
            else if (!!data.GroupChat?.ID) {
                MessageService.deleteGroupChatHistory(data?.GroupChat?.ID).then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                    UpdateHistory(dispatch, data.GroupChat?.ID, [])
                    LoadMessages(dispatch)
                });
            } else {
                MessageService.deleteHistory(data?.PhoneNumber).then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                    UpdateHistory(dispatch, (data.PhoneNumber.replace('+', '')), [])
                    LoadMessages(dispatch)
                });
            }
            props.handleShowMultiActionButtons(false)
            navigate(AppRoutes.CONVERSATIONS)
        }
        else {
            setShowDeleteHistoryDialog(false)
        }
    }

    const openBlockConfirmDialog = (isBlocked: boolean) => {
        setShowBlockContactDialog(true)
        setText(isBlocked ? appNote.UNBLOCK_CONTACT : appNote.BLOCK_CONTACT)
        setDailogButtonName(isBlocked ? buttonLabels.UNBLOCK : buttonLabels.BLOCK)
        setIsLoading(false)
    }

    const closeBlockContactDialog = (isConfim: boolean, event?: any) => {
        event.stopPropagation();
        if (isConfim) {
            let Name = !!data.Campaign?.ID ? !!data.Campaign.Name ? UtilityService.trimMessage(data.Campaign?.Name, 13) : UtilityService.truncateNumbers(data.Campaign?.ToPhoneNumbers) : data.GroupChat?.Name ? UtilityService.trimMessage(data.GroupChat?.Name, 15) : data.GroupChat?.PhoneNumbers ? UtilityService.truncateNumbers(data.GroupChat?.PhoneNumbers) : data.Contact?.Name.replace(/null/g, '') ? UtilityService.trimMessage(data.Contact?.Name.replace(/null/g, ''), 18) : data.MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(data.PhoneNumber);
            setIsLoading(true)
            ContactService.blockUnBlockNumber(data.PhoneNumber, !data.IsBlocked).then(results => {
                setShowBlockContactDialog(false)
                setToast(!data.IsBlocked ? ToasterTexts.CONTACT_BLOCK_SUCCESS.replace('<Name>', Name || data.PhoneNumber) : ToasterTexts.CONTACT_UNBLOCK_SUCCESS.replace('<Name>', Name || data.PhoneNumber), ToasterType.SUCCESS);
            }).catch(error => {
                console.log("error while blocking the contact", error)
            }).finally(() => {
                setIsLoading(false)
                setShowBlockContactDialog(false)
            })
        } else {
            setShowBlockContactDialog(false)
        }
    }

    const handelMarkAsRead = (event?: any) => {
        if (params["*"] === data.PhoneNumber.replace("+", "")) {
            navigate(AppRoutes.CONVERSATIONS)
        }
        if (!!data.GroupChat?.ID) {
            MessageService.groupChatReadOrUnread(data.GroupChat?.ID, data.GroupChat?.UnReadCount > 0 ? 0 : 1).then(() => {
                setToast(data.GroupChat?.UnReadCount > 0 ? ToasterTexts.MARK_AS_READ_SUCCESS : ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            })
        }
        else {
            ContactService.setUnreadMessageCount(data.PhoneNumber, 1 - data.UnReadCount).then(() => {
                setToast(data.UnReadCount > 0 ? ToasterTexts.MARK_AS_READ_SUCCESS : ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            })
        }
    }


    const handeleDownloadChat = () => {
        if (!!data.GroupChat?.ID) {
            setToast(ToasterTexts.DOWNLOADING_CHAT.replace('<Name>', data.GroupChat?.Name ? data.GroupChat?.Name : "Group Chat"), ToasterType.INFO)
            MessageService.downloadGroupChatHistory(data.GroupChat?.ID).then(res => {
                downloadFile(res.data, data.GroupChat?.Name ? data.GroupChat?.Name : "Group Chat")
                setToast(`Chat history for ${!!data.GroupChat?.Name ? data.GroupChat?.Name : "Group Chat"} downloaded successfully.`, ToasterType.SUCCESS);

            })
        }
        else {
            setToast(ToasterTexts.DOWNLOADING_CHAT.replace('<Name>', !!data.Contact?.Name ? data.Contact?.Name : UtilityService.maskPhoneNumberOnLength(data.PhoneNumber)), ToasterType.INFO)
            MessageService.downloadHistoryText(UtilityService.unmaskPhoneNumber(data.PhoneNumber)).then(res => {
                downloadFile(res.data, !!data.Contact?.Name ? data.Contact?.Name : data.PhoneNumber)
                setToast(`Chat history for ${!!data.Contact?.Name ? data.Contact?.Name : data.PhoneNumber} downloaded successfully.`, ToasterType.SUCCESS);

            })
        }
    }

    const downloadFile  = (data: any, name: string) => {
        if (UtilityService.isTeamsMobileClient()) {
            saveBlobOnDevice(new Blob([data], { 
                type: "application/text"
            }), `Falkon SMS-${name}.txt`);
        } else {
            const link = document.createElement("a");
            link.href = URL.createObjectURL(new Blob([data], {
                type: "application/text"
            }));
            link.setAttribute("download", `Falkon SMS-${name}.txt`);
            link.click();
        }
    }

    const handleCheckboxChange = (e) => {
        e.stopPropagation();
        const newValue = e.target.checked;
        setChecked(newValue);
        props.onConversationSelect(data)
    };

    const optionData =
        [{
            Name: data.IsArchived ? ActionLabels.UNARCHIVE : ActionLabels.ARCHIVE,
            Icon: data.IsArchived ? UnArchivedIcon : ArchivedIcon,
            OnClick: () => handelArchive(data.PhoneNumber, data.IsArchived, data.GroupChat?.ID),
        },
        {
            Name: data.IsPinned ? ActionLabels.UNPIN : ActionLabels.PIN,
            Icon: data.IsPinned ? UnpicIcon : PinIcon,
            OnClick: () => handelPin(data.PhoneNumber, data.IsPinned, data.GroupChat?.ID),
            Hide: isSecureChat || data.IsArchived,
        },
        {
            Name: data.IsMuted ? ActionLabels.UNMUTE : ActionLabels.MUTE,
            Icon: data.IsMuted ? UnMuteIcon : MuteIcon,
            OnClick: (e) => data.IsMuted ? muteConversation(e) : setShowMuteForm(true),
            Hide: isSecureChat || !!data.Campaign && data.Campaign.ID ? true : false
        },
        {
            Name: ActionLabels.FOLLOWUP,
            Icon: StarBlackIcon,
            OnClick: (e) => handleFollowUpStatus(e),
            Hide: (data.AssignStatus === StatusEnum.FollowUp || isSecureChat || !!data.GroupChat?.ID || !!data.Campaign?.ID)
        },
        {
            Name: (data.GroupChat?.UnReadCount || data.UnReadCount) > 0 ? ActionLabels.MARK_AS_READ : ActionLabels.MARK_AS_UNREAD,
            Icon: (data.GroupChat?.UnReadCount || data.UnReadCount) > 0 ? MarkasReadIcon : MarkasUnreadIcon,
            OnClick: (e) => handelMarkAsRead(e),
            Hide: isSecureChat || !!data.Campaign && data.Campaign.ID ? true : false,
        },
        {
            Name: ActionLabels.DOWNLOAD_CHAT,
            Icon: DownloadChatIcon,
            OnClick: () => handeleDownloadChat(),
            Hide: isSecureChat || !!data.Campaign && data.Campaign.ID ? true : false,
        },
        {
            Name: data.IsBlocked ? ActionLabels.UNBLOCK : ActionLabels.BLOCK,
            Icon: BlockIcon,
            OnClick: () => openBlockConfirmDialog(data.IsBlocked),
            Hide: isSecureChat || (!!data.GroupChat?.ID || !!data.Campaign?.ID)
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            OnClick: () => setShowDeleteHistoryDialog(true),
            Hide: isSecureChat
        }]

    const MuteOptions = [
        { name: "For 1 hour", value: 1 },
        { name: "For 1 day", value: 24 },
        { name: "Always", value: -1 }
    ];

    const handleMouseEnter = () => {
        if (!IsMobileDevice)
            setIsTooltipHovered(true);
    }

    const handleMouseLeave = () => {
        if (!IsMobileDevice)
            setIsTooltipHovered(false);
    }

    const displayGroupChatName = () => {
        const trimSize = showContactInfo ? 8 : 12;
        if (!data.GroupChat?.Name) {
            let name = data.GroupChat?.PhoneNumbers
                ?.map(number => {
                    let contact = Contacts.find(x => x.PhoneNumber?.replace("+", "") === number?.replace("+", ""));
                    return {
                        name: contact ? contact.Name : number,
                        isContact: !!contact
                    };
                }).sort((a, b) => Number(b.isContact) - Number(a.isContact))
                .map(item => item.name)
                .join(", ");
            return UtilityService.trimMessage(name, trimSize)
        }
        else {
            return UtilityService.trimMessage(data.GroupChat?.Name, trimSize)
        }
    }

    const handleFollowUpStatus = (e) => {
        e.stopPropagation();
        setShowFollowUpIcon(false)
        const data = {
            "contactNumber": props.data.PhoneNumber,
            "status": StatusEnum.FollowUp,
            "assignee": props.data.Assignee,
            "isStatusChange": true,
            "isAssigneeChange": false
        }
        MessageService.updateConversationAssignStatus(data).then((res) => {
        }).catch((err) => {
            setShowFollowUpIcon(true)
        })
        navigate(AppRoutes.CONVERSATIONS)
    };

    const currentUserId = UserService.getCurrentUserId()
    const typingUsers = AllUsers.filter(x => x.ID !== currentUserId && PhoneNumberTypingData.map(y => y.UserID).includes(x.ID))
    const typingUserNames = typingUsers.map(x => x.FirstName).join(", ").trim()
    const safeStyle = style && typeof style === "object" && !Array.isArray(style) ? style : undefined
    return (
        <div className={`ml-1 ${data?.IsActive ? "bg-color-con-hist-inbound-msg-bg" : ""} ${!props.isEndScroll && "conv-card-border br-2 c-pointer d-flex align-center justify-center"}`} style={safeStyle} key={index} onClick={handleCardClick} id={index.toString()} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {props.isEndScroll
                ?
                <>
                    <div className="text-between-line color-con-hist-msg-date h7-regular disabled mt-1">
                        {data.PhoneNumber}
                    </div>
                    {!isSecureChat && <div className="mx-auto t-align-center color-con-hist-msg-date h7-regular p-1">
                        {data.Message}
                        <span onClick={(e) => { e.stopPropagation(); (!IsMobileDevice && navigate(AppRoutes.MESSAGE_LOGS, { replace: true })) }} className={`${!IsMobileDevice ? ' c-pointer t-decoration-underline color-primary-light' : ""}`}> message logs</span>
                    </div>}
                </>
                : <>
                    <span className='d-flex w-p-100 align-center' key={data.ID + data.PhoneNumber}>
                        <span className={`${data.IsBlocked ? "conv-card blocked" : data.IsUnsubscribed ? "conv-card unsubscribed" : "conv-card default"}`} />
                        <div className={`d-flex w-p-100 highlight-conv-card-hover py-1 align-center`}>
                            {props.showCheckboxes ?
                                <div className='mx-2'>
                                    <div className='w-5 h-5 convo-icon-align' onClick={(e) => e.stopPropagation()}>
                                        <Checkbox icon={IsDarkMode ? <ConversationSelectDark /> : <CheckboxDefaultIcon />} checkedIcon={<CheckboxCheckedIcon />} checked={checked} onChange={handleCheckboxChange} size="small" />
                                    </div>
                                </div>
                                :
                                <div className='w-p-15 d-flex justify-center'>
                                    {!isSecureChat && isTooltipHovered ? (
                                        <div className='w-5 h-5 convo-icon-align' onClick={(e) => e.stopPropagation()}>
                                            <Checkbox icon={IsDarkMode ? <ConversationSelectDark /> : <CheckboxDefaultIcon />} checkedIcon={<CheckboxCheckedIcon />} checked={checked} onChange={handleCheckboxChange} size="small" />
                                        </div>
                                    ) : (
                                        <>
                                            {!!data.Campaign && !!data.Campaign.ID ? <Tooltip title="Group Broadcast" placement="bottom"><div className="w-5 h-5 d-flex align-center justify-center bg-color-campaign-avator-icon-bg br-50"><CampainNewIcon /></div></Tooltip> : data.GroupChat?.ID ? <Tooltip title="Group Chat" placement="bottom"><div className="w-5 h-5 d-flex align-center justify-center bg-color-groupchat-avator-icon-bg br-50"><GroupChatNewIcon /></div></Tooltip> : <Avatar Name={data.Contact?.Name || ""} PhoneNumber={data.PhoneNumber} Index={index} Size={35} />}
                                        </>
                                    )}
                                </div>
                            }
                            <div className='d-flex flex-direction w-p-82 mr-2'>
                                <div className='d-flex justify-between align-center w-p-100'>
                                    <span className='h4-regular o-hidden w-space t-overflow-ellipsis w-p-55'>
                                        {!!data.Campaign?.ID
                                            ? !!data.Campaign.Name
                                                ? data.Campaign?.Name
                                                : data.Campaign?.ToPhoneNumbers
                                            : !!data.GroupChat?.ID
                                                ? displayGroupChatName()
                                                : data.Contact?.Name.replace(/null/g, '')
                                                    ? data.Contact?.Name.replace(/null/g, '')
                                                    : data.MaskedPhoneNumber || UtilityService.maskPhoneNumberOnLength(data.PhoneNumber)
                                        }

                                        {!isSecureChat &&
                                            SecureChatConversations.map(x => x.PhoneNumber).find(y => y === props.data.PhoneNumber) &&
                                            <SecureChatFilledIcon className='w-2 h-2 ml-1' />
                                        }
                                    </span>
                                    <span className='h5-regular color-conv-date w-p-45 d-flex align-center justify-flex-end'>
                                        {!isSecureChat && !data.Campaign?.ID && !data.GroupChat?.ID && !props.showContactInfo && <span className='d-flex align-center'>
                                            {(showFolloUpIcon && props.data.AssignStatus !== StatusEnum.FollowUp) && !IsMobileDevice && <span className='d-hover' onClick={(e) => handleFollowUpStatus(e)}>
                                                <Tooltip title={"Mark as follow up"}
                                                    placement='top'
                                                ><span>⭐</span>
                                                </Tooltip>
                                            </span>}
                                            <span className='d-flex align-center mx-1'>
                                                <Tooltip
                                                    title={
                                                        UserService.getCurrentUserFromLocalStorage().ID === data.Assignee
                                                            ? "Assigned to you"
                                                            : AllUsers.find(x => x.ID === data.Assignee)?.FirstName ?? "Unassigned"
                                                    }
                                                    placement='top'
                                                >
                                                    {UserService.getCurrentUserFromLocalStorage().ID === data.Assignee
                                                        ? <AssigneeToYouUserIcon />
                                                        : data.Assignee === null ? <UnAssignedIcon /> : <AssigneeToAnotherUserIcon />
                                                    }
                                                </Tooltip>
                                            </span>
                                            <span className='d-flex align-center h-3 w-3'>
                                                {!showFolloUpIcon ? <Tooltip title='Folow up' placement='top'><span>⭐</span></Tooltip> : (data.AssignStatus === StatusEnum.Open || !data?.AssignStatus) ?
                                                    <Tooltip title='Open' placement='top'><ConversationOpenIcon /></Tooltip>
                                                    : data.AssignStatus === StatusEnum.InProgress ?
                                                        <Tooltip title='In progress' placement='top'><ConversationInProgressIcon /></Tooltip> :
                                                        data.AssignStatus === StatusEnum.Resolved ?
                                                            <Tooltip title='Resolved' placement='top'><ConversationReslovedIcon /></Tooltip> : data.AssignStatus === StatusEnum.Closed ?
                                                                <Tooltip title='Closed' placement='top'><ConversationClosedIcon /></Tooltip> : !!data?.AssignStatus && <Tooltip title='Folow up' placement='top'><span>⭐</span></Tooltip>}

                                            </span>
                                        </span >}
                                        <span>{UtilityService.displayTime(data.MessageDateTime)}</span>
                                    </span>
                                </div>
                                <div className='d-flex justify-between'>
                                    <span className={`h5-regular ${IsDarkMode ? "" : "color-conv-subtitle"} my-auto`}>
                                        {typingUserNames ?
                                            <div>
                                                {typingUserNames} {typingUsers.length > 1 ? "are" : "is"} typing…
                                            </div> :
                                            !(props.data.ID === "endScroll") ? displayMessage(data) : data.Message
                                        }
                                    </span>
                                    <span className='d-flex my-auto align-center'>
                                        {!!data.IsMuted &&
                                            <MuteIcon className="conv-card-icon" />}
                                        {!!data.IsPinned &&
                                            <PinIcon className="conv-card-icon" />}
                                        {!!data.IsArchived &&
                                            <ArchivedIcon className="conv-card-icon" />}
                                        {(data.UnReadCount || data.GroupChat?.UnReadCount) > 0 && <div className={"c-pointer mr-1"}>
                                            <div className={`conv-unread-badge d-flex b-none min-h-3 min-w-3 ${(data.UnReadCount || data.GroupChat?.UnReadCount) > 999 ? "br-1" : "br-p-50"}`}>
                                                <span className="m-auto">
                                                    {data.GroupChat ? data.GroupChat?.UnReadCount : data.UnReadCount}
                                                </span>
                                            </div>
                                        </div>}

                                        {<MenuItemRender HorizantelIcon={true} ClassName={"d-hover opacity-2"} MenuData={optionData} Data={data} MeetBallIcon={SettingsHorizIcon} />}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </span>
                </>}
            {showDeleteHistoryDialog &&
                <ConfirmDialog
                    onClose={closeDeleteHistoryDialog}
                    Show={showDeleteHistoryDialog}
                    Text={appNote.CONVERSATION_DELETE}
                    ButtonName={buttonLabels.DELETE}
                    Loading={isLoading}
                />
            }
            {
                showBlockContactDialog &&
                <ConfirmDialog
                    onClose={closeBlockContactDialog}
                    Show={showBlockContactDialog}
                    Text={text}
                    ButtonName={dailogButtonName}
                    Loading={isLoading}
                />
            }

            {
                showMuteForm &&
                <Dialog
                    open={showMuteForm}
                    onClose={(event: React.SyntheticEvent, reason) => {
                        event.stopPropagation()
                        if (reason !== 'backdropClick') {
                            setShowMuteForm(false)
                        }
                    }}
                    onClick={(event: React.SyntheticEvent) => {
                        event.stopPropagation()
                    }}
                    BackdropProps={{ style: { backgroundColor: "transparent" } }}
                    classes={{ paper: `${IsMobileDevice ? "w-p-100" : "w-p-35"} br-2 dialogue-shadow` }}
                >
                    <DialogTitle className="p-2">
                        <div className="d-flex justify-between">
                            <span className={`ml-1 h1-semibold`}>
                                {`Mute  ${!!data.GroupChat?.ID ? data.GroupChat?.Name ? data.GroupChat?.Name : "Group Chat" : data.Contact?.Name ? data.Contact?.Name : data.MaskedPhoneNumber}`}
                            </span>
                            <Tooltip title='Close' placement='bottom'>
                                <span><CancelIcon className={"c-pointer ml-auto mr-1"} onClick={() => setShowMuteForm(false)} />
                                </span>
                            </Tooltip>
                        </div>
                    </DialogTitle>
                    <div className={"bb-primary-background-pink-4 mx-3"}></div>
                    <DialogContent>
                        <DialogContentText className="pt-2 color-conv-hist-menu">
                            <FormControl component="fieldset" fullWidth>
                                <RadioGroup>
                                    {MuteOptions.map((option) => (
                                        <FormControlLabel
                                            value={option.value}
                                            checked={option.value === muteDuration}
                                            control={<Radio />}
                                            label={option.name}
                                            key={option.value}
                                            onClick={(event: any) => event.stopPropagation()}
                                            onChange={(event: any) => {
                                                if (event.target.checked) {
                                                    setMuteDuration(option.value)
                                                }
                                            }}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="pb-2">
                        <ButtonComponent OnClick={() => setShowMuteForm(false)} ButtonLabel={buttonLabels.CANCEL.toUpperCase()} ClassName={"c-pointer"} Variant={"secondary-btn-small"} />
                        <ButtonComponent OnClick={(e: any) => muteConversation(e)} ButtonLabel={ActionLabels.MUTE} ClassName={"c-pointer mr-1 px-4"} Variant={"primary-btn-small"} Loading={isLoading} />
                    </DialogActions>
                </Dialog>
            }
        </div >
    )
}



export default memo(ConversationCards)